<div class="dialog-header">
  <mat-icon class="dialog-back" [mat-dialog-close]="null">chevron_left</mat-icon>
  <span class="dialog-title">{{ dialogTitle }}</span>
  <mat-icon class="dialog-close" [mat-dialog-close]="null">close</mat-icon>
</div>
<div class="dialog-body">
  @if (blockTypeName === 'logo') {
    <label class="field-label">Logo-Datei</label>
    <div class="file-upload-row" (click)="fileInput.click()">
      <mat-icon class="upload-icon">cloud_upload</mat-icon>
      <span class="upload-label">Datei Upload*</span>
      <span class="upload-hint">(Max. 3 MB, Formate: jpg, png)</span>
      <input #fileInput type="file" accept=".jpg,.jpeg,.png" (change)="onFileSelected($event)">
    </div>
    @if (fileError) {
      <p class="file-error">{{ fileError }}</p>
    }
    @if (logoPreviewUrl) {
      <div class="image-preview">
        <img [src]="logoPreviewUrl" alt="Logo-Vorschau" style="max-width: 100%; border-radius: 8px;">
      </div>
    }
  }

  @if (blockTypeName === 'address') {
    <label class="field-label">Straße</label>
    <input class="field-input" [formControl]="$any(form.controls['street'])">

    <label class="field-label">PLZ</label>
    <input class="field-input" [formControl]="$any(form.controls['postal_code'])">

    <label class="field-label">Stadt</label>
    <input class="field-input" [formControl]="$any(form.controls['city'])">
  }

  @if (blockTypeName === 'phone') {
    <label class="field-label">Telefonnummer</label>
    <input class="field-input" [formControl]="$any(form.controls['phone'])">
  }

  @if (blockTypeName === 'website') {
    <label class="field-label">Website-URL</label>
    <input class="field-input" [formControl]="$any(form.controls['website'])">
  }
</div>
<div class="dialog-footer">
  <button class="dialog-save-btn" (click)="save()" [disabled]="!isValid">Speichern</button>
</div>
